var map = {
	"./10000HZ.wav": 9077,
	"./1000HZ.wav": 8355,
	"./2000HZ.wav": 3282,
	"./250HZ.wav": 5209,
	"./3000HZ.wav": 3005,
	"./4000HZ.wav": 7092,
	"./5000HZ.wav": 135,
	"./500HZ.wav": 8057,
	"./6000HZ.wav": 7574,
	"./7000HZ.wav": 2897,
	"./8000HZ.wav": 9304,
	"./9000HZ.wav": 8203
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 172;